import React, { useState, useEffect } from "react";
import { Spin, Alert, Card, Divider, Button, Modal } from "antd";
import { LoadingOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  currency,
  shippingType,
  loadType,
  shippingTypesCls,
} from "../search/constants";
import { transportType, bodyType } from "../search/categories";
import { useHome } from "../../pages/Home";

import OrdersModal from "../suggest-order/OrdersModal";

const DriverInfo = ({ _driver }) => {
  const { setSelectedTransport } = useHome();
  const navigate = useNavigate();
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [transport, setTransport] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getDriver();
  }, []);

  useEffect(() => {
    if (!driver) {
      return;
    }
    fetchTransport();
  }, [driver]);

  const fetchTransport = async () => {
    setLoading(true);
    try {
      const { data, status } = await axios.get(
        `${process.env.REACT_APP_API_URL}/transports/`,
        {
          headers: {
            Authorization: `JWT ${window.localStorage.getItem("access")}`,
          },
        },
      );

      const _transport = data.find((item) => item.owner.id === driver.id);

      if (status === 200) {
        setTransport(_transport);
      }
    } catch (error) {
      console.log(error);
      setError("Произошла ошибка!");
    } finally {
      setLoading(false);
    }
  };

  const getDriver = async () => {
    setLoading(true);
    try {
      const { data, status } = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/users/${_driver.id}/`,
        {
          headers: {
            Authorization: `JWT ${window.localStorage.getItem("access")}`,
          },
        },
      );

      if (status === 200) {
        setDriver(data);
      }
    } catch (error) {
      console.log(error);
      setError("Произошла ошибка!");
      alert("aaaa");
    } finally {
      setLoading(false);
    }
  };

  const suggestOrderModal = () => {
    setShowModal(true);
  };

  console.log("driver", transport);

  let distance = null;

  if (driver && driver.distance) {
    // Handle both км (kilometers) and м (meters) units
    if (driver.distance.includes("км")) {
      distance = driver.distance.split("км")[0].trim();
    }
  }

  return (
    <div className="driver-info">
      {loading && (
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 32,
              }}
              spin
            />
          }
        />
      )}
      {error && <Alert message={error} type="error" showIcon />}
      <div className="transport">
        {showModal && (
          <OrdersModal
            showModal={showModal}
            setShowModal={setShowModal}
            driver={{ ...driver, user: driver }}
          />
        )}
        {driver && (
          <div className="transport__wrapper">
            <div className="transport__driver transport__driver-map">
              <div className="transport__driver__media">
                <img src={driver.avatar} alt="" />
              </div>
              <div className="transport__driver__info">
                <div className="transport__driver__info__name">
                  {driver.first_name} {driver.last_name}
                </div>
                <div className="transport__driver__info__id">
                  <div className="transport__driver__info__id__num">
                    ID {driver.id}
                  </div>
                  {transport && <div className={`transport__driver__status transport__driver__status--${transport.owner.online === 3 ? "loaded" : "searching"}`}>
                    {transport.owner.online === 3 && (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.999 1.00012C18.0742 1.00012 22.999 5.92499 22.999 12.0001C22.999 18.0753 18.0742 23.0001 11.999 23.0001C5.92389 23.0001 0.999023 18.0753 0.999023 12.0001C0.999024 5.92499 5.92389 1.00012 11.999 1.00012ZM11.999 3.00012C7.02846 3.00012 2.99902 7.02956 2.99902 12.0001C2.99902 16.9707 7.02846 21.0001 11.999 21.0001C16.9696 21.0001 20.999 16.9707 20.999 12.0001C20.999 7.02956 16.9696 3.00012 11.999 3.00012Z" fill="white" />
                        <path d="M15.7045 8.2045C16.1438 7.76517 16.856 7.76517 17.2953 8.2045C17.7347 8.64384 17.7347 9.35599 17.2953 9.79533L11.2953 15.7953C10.856 16.2347 10.1438 16.2347 9.70451 15.7953L6.7045 12.7953C6.26517 12.356 6.26517 11.6438 6.7045 11.2045C7.14384 10.7652 7.85599 10.7652 8.29533 11.2045L10.4999 13.4091L15.7045 8.2045Z" fill="white" />
                      </svg>
                    )}

                    {transport.owner.online !== 3 && (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM15.8846 17.2987C15.6562 17.0703 15.323 17 15 17H9C8.77658 17 8.55133 17.06 8.39335 17.218L7.29652 18.3148C6.87071 18.7406 6.91381 19.4479 7.43224 19.7543C8.77099 20.5454 10.3321 21 12 21C13.7244 21 15.3341 20.5134 16.7022 19.6718C17.2098 19.3596 17.2467 18.6608 16.8253 18.2394L15.8846 17.2987ZM4.1733 13C3.5775 13 3.10944 13.52 3.24808 14.0995C3.48374 15.0844 3.88159 16.0062 4.4114 16.8356C4.72898 17.3328 5.41948 17.3637 5.83662 16.9466L6.67008 16.1131C6.94264 15.8406 7.01042 15.4347 7.00063 15.0494C7.00021 15.033 7 15.0165 7 15V14C7 13.4477 6.55228 13 6 13H4.1733ZM17 15C17 15.323 17.0703 15.6562 17.2987 15.8846L18.239 16.825C18.6606 17.2465 19.3596 17.2095 19.6717 16.7016C20.16 15.9073 20.5286 15.0317 20.7518 14.0994C20.8906 13.52 20.4225 13 19.8267 13H18C17.4477 13 17 13.4477 17 14V15ZM12 3C7.75253 3 4.1937 5.94251 3.24797 9.90018C3.1095 10.4797 3.5775 11 4.1733 11H6C6.55228 11 6.97928 10.5255 7.24447 10.041C7.58407 9.42067 8.24291 9 9 9H15C15.7571 9 16.4159 9.42067 16.7555 10.041C17.0207 10.5255 17.4477 11 18 11H19.8267C20.4225 11 20.8905 10.4797 20.752 9.90018C19.8063 5.94251 16.2475 3 12 3Z" fill="#F2994A" />
                        <path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM15.8846 17.2987C15.6562 17.0703 15.323 17 15 17H9C8.77658 17 8.55133 17.06 8.39335 17.218L7.29652 18.3148C6.87071 18.7406 6.91381 19.4479 7.43224 19.7543C8.77099 20.5454 10.3321 21 12 21C13.7244 21 15.3341 20.5134 16.7022 19.6718C17.2098 19.3596 17.2467 18.6608 16.8253 18.2394L15.8846 17.2987ZM4.1733 13C3.5775 13 3.10944 13.52 3.24808 14.0995C3.48374 15.0844 3.88159 16.0062 4.4114 16.8356C4.72898 17.3328 5.41948 17.3637 5.83662 16.9466L6.67008 16.1131C6.94264 15.8406 7.01042 15.4347 7.00063 15.0494C7.00021 15.033 7 15.0165 7 15V14C7 13.4477 6.55228 13 6 13H4.1733ZM17 15C17 15.323 17.0703 15.6562 17.2987 15.8846L18.239 16.825C18.6606 17.2465 19.3596 17.2095 19.6717 16.7016C20.16 15.9073 20.5286 15.0317 20.7518 14.0994C20.8906 13.52 20.4225 13 19.8267 13H18C17.4477 13 17 13.4477 17 14V15ZM12 3C7.75253 3 4.1937 5.94251 3.24797 9.90018C3.1095 10.4797 3.5775 11 4.1733 11H6C6.55228 11 6.97928 10.5255 7.24447 10.041C7.58407 9.42067 8.24291 9 9 9H15C15.7571 9 16.4159 9.42067 16.7555 10.041C17.0207 10.5255 17.4477 11 18 11H19.8267C20.4225 11 20.8905 10.4797 20.752 9.90018C19.8063 5.94251 16.2475 3 12 3Z" fill="white" />
                      </svg>
                    )}
                    <div
                      className="transport__driver__status__text"
                    >
                      {transport && transport.owner.online !== 1
                        ? "Груженный"
                        : "Ищу груз"}
                    </div>
                  </div>}
                </div>
              </div>
            </div>
            {(transport && transport.owner.online === 1) && (
              <div
                className="transport__destinations"
                style={{ border: "none" }}
              >
                <div className="transport__destinations__left">
                  {driver.location_from.split(", ")[0] !== driver.from_country && <div className="transport__destination__city">
                    {driver.location_from.split(", ")[0]}
                  </div>}
                  {driver.location_from.split(", ")[0] === driver.from_country && <div className="transport__destination__city">
                    &nbsp;
                  </div>}
                  <div className="transport__destination__icon__wrapper transport__destination__icon__wrapper--from">
                    <div className="transport__destination__icon transport__destination__icon--from">
                      A
                    </div>
                  </div>
                  <div className="transport__destination__country">
                    <strong>{driver.from_country_code}</strong>,{" "}
                    {driver.from_country}
                  </div>
                </div>
                <div className="transport__destinations__middle">
                  <div className="transport__destinations__middle__border" />
                  <div className="transport__destinations__middle__distance">
                    <div className="transport__destinations__middle__distance__icon" />
                    {distance ? driver.distance : ""}
                  </div>
                </div>
                <div className="transport__destinations__right">
                  {driver.location_to.split(", ")[0] !== driver.to_country && <div className="transport__destination__city">
                    {driver.location_to.split(", ")[0]}
                  </div>}
                  {driver.location_to.split(", ")[0] === driver.to_country && <div className="transport__destination__city">
                    &nbsp;
                  </div>}
                  <div className="transport__destination__icon__wrapper transport__destination__icon__wrapper--to">
                    <div className="transport__destination__icon transport__destination__icon--to">
                      B
                    </div>
                  </div>
                  <div className="transport__destination__country">
                    <strong>{driver.to_country_code}</strong>,{" "}
                    {driver.to_country}
                  </div>
                </div>
              </div>
            )}
            <div className="transport__suggest-order">
              <Button type="primary" onClick={suggestOrderModal}>
                Предложить груз
              </Button>
              <span>&nbsp;</span>
              <span>&nbsp;</span>
              <Button
                type="primary"
                className="my-custom-btn bordered"
                onClick={() => {
                  // Navigate to the transport detail route using React Router
                  if (transport && transport.owner && transport.owner.id) {
                    navigate(`/transports/${transport.owner.id}`);
                  }
                }}
              >
                Детали водителя
              </Button>
            </div>
            {/* <div className="transport__price">
            <div className="transport__price__icon" />
            {!driver.price_from && <strong>
              Ждем предложения
              </strong>
            }
            {driver.price_from && <>
              <strong>{driver.price_from} {currency(driver.currency || null)}</strong>&nbsp;<span style={{color: "#72809D", fontSize: "14px"}}>&bull; {driver.nds ? 'с НДС' : 'без НДС'}</span>
            </>}
          </div>
          <div className={`transport__price transport__type ${shippingTypesCls[driver.shipping_type]}`}>
            <div className="transport__price__icon"></div><strong>{shippingType(driver.shipping_type)}</strong>
          </div>
          {transport && <div className="transport__badges">
            {transportType(transport.category) && <div className={`transport__badge transport__category transport__type ${transportType(transport.category).className}`}>
              {transportType(transport.category).label}
            </div>}
            {bodyType(transport.body_type) && <div className="transport__badge transport__type">
              {bodyType(transport.body_type)}
            </div>}
            <div className="transport__badge transport__type_of_load">{loadType(transport.type_of_load)}</div>
            <div className="transport__badge transport__max_load_weight_max">{driver.weight} кг.</div>
            <div className="transport__badge">{driver.volume} м3.</div>
          </div>} */}
          </div>
        )}
      </div>
    </div >
  );
};

export default DriverInfo;
